export default {
  pollInterval: 500,
};
